export default "__VITE_ASSET__DtO3DBuP__"